import { render, staticRenderFns } from "./InvoiceCorrectionsForm.vue?vue&type=template&id=e2803ada&"
import script from "./InvoiceCorrectionsForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceCorrectionsForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCorrectionsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports